import { datadogRum } from '@datadog/browser-rum';

class LoggerService {
    logError(message: string, context?: Record<string, any>) {
        const error = new Error(message);
        datadogRum.addError(error, context);
    }

    logInfo(message: string, context?: Record<string, any>) {
        datadogRum.addAction('info', { message, ...context });
    }

    logWarning(message: string, context?: Record<string, any>) {
        datadogRum.addAction('warning', { message, ...context });
    }
}


export const loggerService = new LoggerService();